import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useNavigate, Link} from 'react-router-dom';
import {useParams} from 'react-router-dom';
import {ContentHeader, Loader} from '@components';
import {logoutUser} from '@app/store/reducers/auth';
import { Button, Modal } from 'react-bootstrap';
import handleStatus from '../../utils/ajax';
import {getDocInfo, getDocFiles, getFileUrl} from '../../services/docs';
import CopyToClipboard from 'react-copy-to-clipboard';
import ViewDocFile from './ViewDocFile';
import {MdImage, MdGif, MdAudioFile} from 'react-icons/md';
import {
  BsFiletypeDocx,
  BsFileZip,
  BsFiletypeCsv,
  BsFileExcel
} from 'react-icons/bs';
import {toast} from 'react-toastify';
import {TbPdf} from 'react-icons/tb';

const ViewDoc = () => {
  const [doc, setDoc] = React.useState({});
  const [showLoader, setShowLoader] = useState(false);
  const [files, setFiles] = useState([]);
  const [links, setLinks] = useState([]);
  const {docId} = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getFileContent = async (fileHash:string): void => {
     const res = await getFileUrl(fileHash);
    if (res.status === 200) { 
      window.open(res.data.imageLink, '_blank').focus();
    } else { 
      window.location.href = '/';
    }

  }
  const getDocInfoFn = async () => {
    setShowLoader(true);
    const res = await getDocInfo(docId);
    handleStatus(res.status, () => dispatch(logoutUser()), navigate);

    const files = await getDocFiles(docId);
    handleStatus(files.status, () => dispatch(logoutUser()), navigate);
    if (files.status === 200 && files.data.ok) {
      setFiles(files.data.data);
      const copy = [...files.data.data];
      const getAllLinks =
        copy &&
        copy.map(async (file, index) => {
          const link = await getFileUrl(file.fileHash);
          return setLinks((prev: any) => [...prev, link.data.imageLink]);
        });
    }

    if (res.data.ok) {
      setDoc(res.data.data);
      setShowLoader(false);
    } else {
    }
  };

  useEffect(() => {
    if (docId) {
      getDocInfoFn();
    }
  }, []);

  if (showLoader) {
    return <Loader title={'Daily'} />;
  }
  const navigateBack = () => {
    navigate(-1);
  };

  const getAssetLink = (id: string): string => {
       return window.location.origin+"/getdoc/"+id
  }

  const getIcon = (file) => {
    if (file === 'png' || file === 'jpg' || file === 'jpeg') {
      return (
        <MdImage
          style={{
            height: '70px',
            width: '70px',
            margin: '8px',
            color: '#17a2b8'
          }}
        />
      );
    }

    if (file === 'gif') {
      return (
        <MdGif
          style={{
            height: '70px',
            width: '70px',
            margin: '8px',
            color: '#17a2b8'
          }}
        />
      );
    }

    if (file === 'mp3') {
      return (
        <MdAudioFile
          style={{
            height: '70px',
            width: '70px',
            margin: '8px',
            color: '#17a2b8'
          }}
        />
      );
    }

    if (file === 'pm4' || file === 'pdf') {
      return (
        <TbPdf
          style={{
            height: '70px',
            width: '70px',
            margin: '8px',
            color: '#17a2b8'
          }}
        />
      );
    }

    if (file === 'xls') {
      return (
        <BsFileExcel
          style={{
            height: '70px',
            width: '70px',
            margin: '8px',
            color: '#17a2b8'
          }}
        />
      );
    }

    if (file === 'csv') {
      return (
        <BsFiletypeCsv
          style={{
            height: '70px',
            width: '70px',
            margin: '8px',
            color: '#17a2b8'
          }}
        />
      );
    }

    if (file === 'zip') {
      return (
        <BsFileZip
          style={{
            height: '70px',
            width: '70px',
            margin: '8px',
            color: '#17a2b8'
          }}
        />
      );
    }

    if (file === 'docx') {
      return (
        <BsFiletypeDocx
          style={{
            height: '70px',
            width: '70px',
            margin: '8px',
            color: '#17a2b8'
          }}
        />
      );
    }
  };

  return (
    <React.Fragment>
      <ContentHeader title={doc.projectId && doc.projectId.projectName} path={`/view-project/${doc?.projectId?._id}`} />
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header view-doc-action">
              <div className="header-text">
                <h3 className="card-title">{doc.documentationName}</h3>
              </div>
              <div className="editbutton d-flex justify-content-end">
                <Link
                  to={`/update-doc/${doc._id}`}
                  className="btn btn-primary btn-sm mr-2"
                >
                  Update Document &nbsp; <i className="fas fa-pencil-alt"></i>
                </Link>
                <div>
                  <Link to="#" onClick={navigateBack}>
                    Back
                  </Link>
                </div>
              </div>
            </div>
            <div
              className="card-body"
              dangerouslySetInnerHTML={{
                __html: doc.text
              }}
            ></div>

            <div className="card-body">
              <h6 className="col-lg">Attachments</h6>
              <div className="container m-0 d-flex flex-row">
                {files.map((file, idx) => (
                  <span
                    key={idx}
                    className="d-flex flex-column align-items-center justify-content-center  m-1"
                  >
                    {/* <Button onClick={() => getFileContent(file.fileHash)}>
                      {getIcon(file.fileName.split('.')[1])}
                    </Button> */}
                     {getIcon(file.fileName.split('.')[1])}
                    <ViewDocFile fileHash={file.fileHash} />
                    <span className="d-flex align-items-center justify-content-center no-wrap flex-column ">
                      {/* <CopyToClipboard
                        text={getAssetLink(file.fileHash)}
                        onCopy={() => toast('Link Copied!')}
                      >
                        <button type="button" className="btn btn-secondary">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-clipboard"
                            viewBox="0 0 16 16"
                          >
                            <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"></path>
                            <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"></path>
                          </svg>
                        </button>
                      </CopyToClipboard> */}

                      <p className="text-wrap text-center word-wrap mx-0 my-1 w-100">
                        {file.fileName.substring(0, 20) + '...'}
                      </p>
                    </span>
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default ViewDoc;
